import useCurrentUser from '~/hooks/useCurrentUser'
import { UserRole } from '~/types/user-info-types'
import useSubscriptionIsRequired from '~/subscription/hooks/useSubscriptionIsRequired'

export default function useSubscriptionNeededForUser(): boolean {
  const { isSubscriptionRequired: subscriptionApplicable } = useSubscriptionIsRequired({ considerPermissions: false })
  const user = useCurrentUser()
  const userRole = user?.role || UserRole.USER
  const internalUser = userRole !== UserRole.USER

  return !internalUser && subscriptionApplicable
}
